export const isLocalhost = () => {
  const { hostname } = window.location;

  return hostname === 'localhost';
};
